module.exports = __webpack_public_path__ + "static/img/QRCode.51017d6.png";


//////////////////
// WEBPACK FOOTER
// ./static/QRCode.png
// module id = MnWE
// module chunks = 1